import { useState, useEffect } from "react";
import OverviewFilter from "../../components/Vessel/OverviewFilter";
import OverviewScores from "../../components/Vessel/OverviewScores";
import LastVoyage from "../../components/Vessel/LastVoyage";
import LatestStatus from "../../components/Vessel/LatestStatus";
import {
  getVesselStatus,
  getVesselVoyage,
} from "../../services/vesselOverviewService";
import { useSelector } from "react-redux";

const VesselOverview = () => {
  const [vesselStatus, setVesselStatus] = useState(null);
  const [vesselVoyage, setVesselVoyage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { currentVessel } = useSelector((state) => state.vesselOverview);

  useEffect(() => {
    if (currentVessel?._id) {
      const fetchVesselData = async () => {
        setLoading(true);
        try {
          const [statusResponse, voyageResponse] = await Promise.all([
            getVesselStatus(currentVessel._id),
            getVesselVoyage(currentVessel._id)
          ]);
          
          if (voyageResponse?.status === "error") {
            setVesselVoyage({});
          } else {
            setVesselVoyage(voyageResponse);
          }

          if (statusResponse?.status === "error") {
            setVesselStatus({});
          } else {
            setVesselStatus(statusResponse);
          }
          setError(null);
        } catch (err) {
          setError(err.message);
          console.error("Error fetching vessel data:", err);
        } finally {
          setLoading(false);
        }
      };

      fetchVesselData();
    }
  }, [currentVessel]);

  return (
    <div className="space-y-6">
      <OverviewFilter />
      {loading && <div>Loading vessel data...</div>}
      {error && <div className="text-red-500">Error: {error}</div>}
      {!loading && !error && (
        <>
          {/* <OverviewScores status={vesselStatus} /> */}
          <LastVoyage lastVoyage={vesselVoyage || {}} />
          <LatestStatus latestStatus={vesselStatus || {}}
          lastVoyage={vesselVoyage || {}} />
        </>
      )}
    </div>
  );
};

export default VesselOverview;
